// import { useLayoutEffect } from 'react';
import {
  HashRouter,
  Routes,
  Route,
  matchPath,
} from 'react-router-dom';

import { Layout } from 'view-layer/components/layout/Layout'
import {
  Main,
  Processing,
  Completed,
  Expired,
  // Declined,
  Pending,
  Error,
  NotFound,
} from 'view-layer/components/pages';
import * as Components from 'view-layer/components';

import { L10nContext } from 'business-layer/contexts/L10nContext';
import { detectLanguage } from 'business-layer/helpers/user';
import { PaymentProvider } from "business-layer/contexts/PaymentContext";

import useFetch, { FetchResult } from 'data-layer/fetch-api/useFetch';
// import { PaymentGatewayRequestService } from "data-layer/services/PaymentGatewayRequestService";
import { LocalizationRequestService } from 'data-layer/services/LocalizationRequestService';
// import { PaymentGatewayDto, LocalizationDto } from 'data-layer/dto';
import { LocalizationDto } from 'data-layer/dto';
import { TocDto } from 'data-layer/dto/TocDto';
import { TocRequestService } from 'data-layer/services/TocRequestService';

export const App = () => {
  const lang: string = detectLanguage();

  // TODO: IDK why it is useEffect needed
  // useEffect(() => {
  if (window.location.hash && !window.location.hash.startsWith('#/')) {
    window.location.hash = '';
  }
  // });
  const match = matchPath({ path: '/payment/:hash', end: false }, window.location.hash.replace('#', ''));
  const hash = match?.params?.hash || '';

  const requestParams = LocalizationRequestService(lang);
  const [ labels, labelsLoading, labelsError ]: FetchResult<LocalizationDto> = useFetch(requestParams, LocalizationDto, hash);
  // const [ gatewayConfig, gatewayLoading, gatewayError ]: FetchResult<PaymentGatewayDto> = useFetch(PaymentGatewayRequestService(hash), PaymentGatewayDto, hash);
  const [ tocData, tocLoading ]: FetchResult<TocDto> = useFetch(TocRequestService(hash, lang), TocDto, hash);

  // const error = Boolean(gatewayError) || Boolean(labelsError);
  // const loading = labelsLoading || gatewayLoading || tocLoading;

  const error = Boolean(labelsError);
  const loading = labelsLoading || tocLoading;

  if (!!error) {
    const errorMessage = typeof error === 'string' ? error : 'Payment not found.';
    return <Components.Layout.MessagePanel message={errorMessage} type="error" />;
  }

  if (loading) {
    return (
      <Components.Common.Loader />
    );
  }

  return (
    <L10nContext.Provider value={{ labels, toc: tocData?.toc, lang }}>
      <PaymentProvider value={{}}>
        <HashRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route path="/payment/:hash" element={<Main />} />
              <Route path="/payment/:hash/processing/:payment" element={<Processing />} />
              <Route path="/payment/:hash/pending" element={<Pending />} />
              <Route path="/payment/:hash/completed" element={<Completed />} />
              <Route path="/payment/:hash/declined" element={<Main declined />} />
              <Route path="/payment/:hash/expired" element={<Expired />} />
              <Route path="/payment/:hash/error" element={<Error />} />
              <Route path="/error" element={<Error />} />
              <Route path="*" element={<NotFound />} />
              <Route index element={<NotFound />} />
            </Route>
          </Routes>
        </HashRouter>
      </PaymentProvider>
    </L10nContext.Provider>
  )
};
